export default __webpack_public_path__ + "static/media/metamask-text.a36768a3.svg";